import { createGlobalStyle } from "styled-components";
import media from "utils/media";

const CSSReset = createGlobalStyle`
  /* The margin/padding/border element reset lives in styles/reset-layer.css,
  * inside @layer reset, so Seeds @layer components rules can override it.
  * *********************************** */

  /* Typography
  * *********************************** */
  html {
    font-size: 62.5%;
  }


  /* Layout
  * *********************************** */
  html, body, #___gatsby, #___gatsby > div {
    height: 100%;
    overflow: hidden !important;

    ${media.small`
      height: auto;
      overflow: auto !important;
    `}
  }

  article,
  aside,
  footer,
  header,
  nav,
  section,
  main {
    display: block;
  }

  * {
    box-sizing: border-box;
  }

  *:before,
  *:after {
    box-sizing: inherit;
  }

  /* Elements
  * *********************************** */
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:after,
  blockquote:before,
  q:after,
  q:before {
    content: "";
    content: none;
  }

  img {
    border-style: none;
  }

  img, video {
    max-width: 100%;
    height: auto;
  }

  img, video, canvas, audio, iframe, embed, object  { 
    display: block;
    vertical-align: middle;
  }
  
  input[type="search"] {
    -webkit-appearance: textfield;
  }

  input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /* Attributes & states
  * *********************************** */
  [hidden] {
    display: none !important;
  }

  [disabled] {
    cursor: not-allowed;
  }

  :focus:not(:focus-visible) {
    outline: none;
  }
`;

export default CSSReset;
